import { useQuery } from 'react-query';
import { getPageContent, getPageContentByKey } from '@/api/cmsService';
import { useMemo } from 'react';

export function useCmsContent(pageSlug: string) {
  const { data: content = [], isLoading, error } = useQuery(
    ['page-content', pageSlug],
    () => getPageContent(pageSlug),
    {
      staleTime: 300000,
      refetchOnWindowFocus: false,
    }
  );

  const getContent = useMemo(() => {
    return function getContentFn(contentKey: string, defaultValue: string = ''): string {
      const item = content.find((c) => c.contentKey === contentKey);
      return item?.contentValue || defaultValue;
    };
  }, [content]);

  return {
    content,
    getContent,
    loading: isLoading,
    error: error instanceof Error ? error.message : null,
  };
}

export function useCmsContentByKey(
  pageSlug: string,
  contentKey: string,
  defaultValue: string = ''
) {
  const { data, isLoading, error } = useQuery(
    ['page-content-key', pageSlug, contentKey],
    () => getPageContentByKey(pageSlug, contentKey),
    {
      staleTime: 300000,
      refetchOnWindowFocus: false,
    }
  );

  return {
    value: data || defaultValue,
    loading: isLoading,
    error: error instanceof Error ? error.message : null,
  };
}
